import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { forwardRef, memo } from 'react';
import { useDatePickerDaySelectorClassNames } from './hooks/useDatePickerDaySelectorClassNames';
import { useDatePickerDaySelector } from './hooks/useDatePickerDaySelector';
import { DatePickerDaySelectorRoot, DatePickerDaySelectorWeek, DatePickerDaySelectorWeekDay, DatePickerDaySelectorDays, DatePickerDaySelectorDay, DatePickerDaySelectorDayPadding, DatePickerDaySelectorDayButton } from './style';
import { DATE_PICKER_DAY_SELECTOR_CLASS_PREFIX } from './constants';
/**
 * @internal
 */
export var DatePickerDaySelector = memo(forwardRef(function DatePickerDaySelector(_ref, ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var classNameComponents = useDatePickerDaySelectorClassNames(DATE_PICKER_DAY_SELECTOR_CLASS_PREFIX, className);
  var _useDatePickerDaySele = useDatePickerDaySelector(props, ref),
    rootProps = _useDatePickerDaySele.rootProps,
    weekDays = _useDatePickerDaySele.weekDays,
    dayMatrix = _useDatePickerDaySele.dayMatrix,
    getDayProps = _useDatePickerDaySele.getDayProps;
  return React.createElement(DatePickerDaySelectorRoot, _objectSpread(_objectSpread({}, rootProps), {}, {
    className: classNameComponents.Root
  }), React.createElement(DatePickerDaySelectorWeek, {
    className: classNameComponents.Week
  }, weekDays.map(function (weekDay) {
    return React.createElement(DatePickerDaySelectorWeekDay, {
      key: weekDay.value,
      className: classNameComponents.WeekDay
    }, weekDay.label);
  })), React.createElement(DatePickerDaySelectorDays, {
    className: classNameComponents.Days
  }, dayMatrix.map(function (day) {
    return React.createElement(DatePickerDaySelectorDay, _objectSpread({
      key: day.id
    }, getDayProps(day, classNameComponents.Day)), React.createElement(DatePickerDaySelectorDayPadding, _objectSpread(_objectSpread({}, day.paddingProps), {}, {
      left: true,
      className: classNameComponents.DayPaddingLeft
    })), React.createElement(DatePickerDaySelectorDayButton, _objectSpread(_objectSpread({}, day.buttonProps), {}, {
      className: classNameComponents.DayButton
    }), day.day), React.createElement(DatePickerDaySelectorDayPadding, _objectSpread(_objectSpread({}, day.paddingProps), {}, {
      right: true,
      className: classNameComponents.DayPaddingRight
    })));
  })));
}));
DatePickerDaySelector.displayName = DATE_PICKER_DAY_SELECTOR_CLASS_PREFIX;